/*
 * PDF plugin
 */

import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.js'
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";

;(function($, $win) {

	'use strict';

	function PDFDisplay($module) {
		this.module = $module;
        this.pageRendering = false;
        this.pageNumPending = null;
        this.pdfDoc = null;
        this.pageNum = 1;
        this.numPages = 1;
        this.canvas = null;
        this.container = null;
		this.init();
	}

	PDFDisplay.prototype = {
		init: function() {
            let self = this;

            var url = this.module.data('pdf-url');

            pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

            // Asynchronous download of PDF
            var loadingTask = pdfjsLib.getDocument(url);
            loadingTask.promise.then(function(pdfDoc_) {
                self.pdfDoc = pdfDoc_;
                self.numPages = pdfDoc_.numPages;
                self.module.find('.block-asset-bar-total-pages').text(self.numPages);
                self.container = self.module.find('.block-ebook-wrapper');
                self.renderPage(1);
                
                if (pdfDoc_.numPages == 1) {
                  self.module.find('a.pdf-arrows').hide();
                }
                else {
                  self.module.find('a.pdf-arrows-prev').addClass("active");
                }

            });

            this.attachEvents();
		},

        attachEvents: function() {
            let self = this;

            this.doPrev = function(e) {
                e.preventDefault();
                if (self.pageNum <= 1) {
                    return;
                }


                self.module.find('a.pdf-arrows-next').removeClass("active");
                self.pageNum--;

                if (self.pageNum == 1) {
                  self.module.find('a.pdf-arrows-prev').addClass("active");
                }

                self.queueRenderPage(self.pageNum);
            };

            this.doNext = function(e) {
                e.preventDefault();
                if (self.pageNum >= self.numPages) {
                    return;
                }
                
                self.module.find('a.pdf-arrows-prev').removeClass("active");

                self.pageNum++;

                if (self.pageNum == self.numPages) {
                  self.module.find('a.pdf-arrows-next').addClass("active");
                }

                self.queueRenderPage(self.pageNum);
            };

            this.goFullscreen = function(e) {
                e.preventDefault();
                self.pdfDoc.fullscreen();
            };

            this.handleResize = function() {
                self.queueRenderPage(self.pageNum);
            };

            this.module.find('a.pdf-prev').bind('click', self.doPrev);

            this.module.find('a.pdf-next').bind('click', self.doNext);

            this.module.find('a.block-asset-bar-fullscreen').bind('click', this.goFullscreen);

            $(window).on('resize', self.handleResize);
        },

        queueRenderPage: function(num) {
            if (this.pageRendering) {
                this.pageNumPending = num;
            } else {
                this.renderPage(num);
            }
        },

        renderPage: function(num, scale = 1) {
            this.pageRendering = true;
            var self = this;
            // Using promise to fetch the page
            this.pdfDoc.getPage(num).then(function(page) {
                // var scale = 1;
                var viewport = page.getViewport({scale: 1});
                scale = self.container.width() / viewport.width;
                viewport = page.getViewport({scale: scale});

                // Support HiDPI-screens.
                var outputScale = window.devicePixelRatio || 1;

                let canvas = self.module.find('canvas').get(0);
                var context = canvas.getContext('2d');

                canvas.width = Math.floor(viewport.width * outputScale);
                canvas.height = Math.floor(viewport.height * outputScale);
                canvas.style.width = Math.floor(viewport.width) + "px";
                canvas.style.height =  Math.floor(viewport.height) + "px";

                var transform = outputScale !== 1
                ? [outputScale, 0, 0, outputScale, 0, 0]
                : null;

                var renderContext = {
                    canvasContext: context,
                    transform: transform,
                    viewport: viewport
                };
                var renderTask = page.render(renderContext);

                // Wait for rendering to finish
                renderTask.promise.then(function() {
                    self.pageRendering = false;
                    if (self.pageNumPending !== null) {
                        // New page rendering is pending
                        self.renderPage(pageNumPending);
                        self.pageNumPending = null;
                    }
                });

                self.module.find('.block-asset-bar-current-page').text(self.pageNum);
            });
        },

		destroy: function() {
			var self = this;

			
		},

		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	};

	$.fn.PDFDisplay = function() {
        new PDFDisplay(this);
        /*
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		var options = $.extend({
			activeClass: 'active',
			addToParent: false,
			autoHeight: false,
			checkHash: false,
			defaultTab: true,
			animSpeed: 500,
			tabLinks: 'a',
			attrib: 'href',
			event: 'click',
			tabHiddenClass: 'js-tab-hidden'
		}, opt);
		options.autoHeight = options.autoHeight;

		return this.each(function() {
			var $holder = jQuery(this);
			var instance = $holder.data('PDFDisplay');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				$holder.data('PDFDisplay', new PDFDisplay($holder, options));
			} else if (typeof method === 'string' && instance) {
				if (typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
        */
	};

}(jQuery, jQuery(window)));
